import { useState } from "react";
import "@/App.css";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import Dashboard from "./pages/Dashboard";
import SettingsPage from "./pages/SettingsPage";
import EnrollmentSetup from "./pages/EnrollmentSetup";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import { Toaster } from "./components/ui/sonner";

function AppContent() {
  const { user, loading, updateUser } = useAuth();
  const [authView, setAuthView] = useState("login");
  const [page, setPage] = useState("dashboard");

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="loading-screen">
        <div className="text-center animate-fade-in">
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">Loading</p>
        </div>
      </div>
    );
  }

  if (!user) {
    if (authView === "register") {
      return <RegisterPage onSwitchToLogin={() => setAuthView("login")} />;
    }
    if (authView === "forgot") {
      return <ForgotPasswordPage onBackToLogin={() => setAuthView("login")} />;
    }
    return <LoginPage onSwitchToRegister={() => setAuthView("register")} onSwitchToForgot={() => setAuthView("forgot")} />;
  }

  // Show enrollment setup for new users
  if (!user.setup_complete && user.setup_complete !== undefined) {
    return (
      <EnrollmentSetup
        onComplete={() => {
          updateUser({ setup_complete: true });
          setPage("dashboard");
        }}
      />
    );
  }

  if (page === "settings") {
    return <SettingsPage onBack={() => setPage("dashboard")} />;
  }

  return <Dashboard onNavigateToSettings={() => setPage("settings")} />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
        <Toaster />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
